import { useParams } from "react-router-dom";

import { PageContainer, PageHeader, PageTitle } from "@/components/page";
import { useAreaContext } from "@/hooks/useAreaContext";

import { ModuleMaintenanceRouteParams } from "./module-maintenance.data-loader";

type ModuleMaintenanceValidatorProps = {
  children: React.ReactNode;
  /** Override the route param. Useful when rendering inside a sheet. */
  moduleAddress?: string;
};

const ModuleMaintenanceValidator = ({
  children,
  moduleAddress: moduleAddressProp,
}: ModuleMaintenanceValidatorProps) => {
  const { area } = useAreaContext();
  const params = useParams<keyof ModuleMaintenanceRouteParams>();
  const moduleAddress = moduleAddressProp ?? (params.moduleAddress as string);

  const parsedAddress = Number(moduleAddress);
  const post = area.posts.find((p) => p.address === parsedAddress);

  if (!post) {
    return (
      <PageContainer>
        <PageHeader>
          <PageTitle>Module introuvable</PageTitle>
        </PageHeader>
        <p tw="text-gray-500">
          Aucun module avec l'adresse {moduleAddress} n'a été trouvé dans la
          parcelle « {area.name} ».
        </p>
      </PageContainer>
    );
  }

  return children;
};

export default ModuleMaintenanceValidator;
